import React, { createContext, useState, useEffect, useContext } from "react";
import { SocketContext } from "./SocketProvider";

/**
 * Allows components to access and modify settings like image count. (Add translation features here!)
 * The context is initialized with a default image count of 8.
 * Components can use the `useSettings` hook to access the context.
 * The `SettingsProvider` component wraps the application and provides the context value.
 */
const SettingsContext = createContext({
  imageCount: 8,
  toggleImageCount: () => {},
});

export const SettingsProvider = ({ children }) => {
  const [imageCount, setImageCount] = useState(8);
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    socket.on("imageCountUpdate", (count) => setImageCount(count));
    return () => socket.off("imageCountUpdate");
  }, [socket]);

  const toggleImageCount = () => {
    const newCount = imageCount === 6 ? 8 : 6;
    setImageCount(newCount);
    socket.emit("imageCountUpdate", newCount);
  };

  return (
    <SettingsContext.Provider value={{ imageCount, toggleImageCount }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
